import { Input } from 'antd';
import React from 'react';

import FieldInputBuffer from '../../components/fieldInputBuffer';

const FieldName = () => {
    return (
        <FieldInputBuffer
            nameField={'name'}
            rulesField={[{ required: true, message: 'Please input item name!' }]}
            inputComponents={(onChange, valueField) => <Input value={valueField} onChange={onChange} />}
        />
    );
};

export default React.memo(FieldName);
